import api from '@/api/api'

class TrackingService {
  sendTrack(eventName, properties) {
    return api.axios.post(`tracking/send-track`, {event_name: eventName, properties});
  }
}

export default new TrackingService();
